import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-email-click';
/**
 * Click email us event at the end of self-serve flow in help center
 */
export function trackHelpCenterEmailClick(retailerToken, brandToken, IssueType) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken, IssueType },
    });
}
